import { render } from "./Signup.vue?vue&type=template&id=3399c735&scoped=true"
import script from "./Signup.vue?vue&type=script&lang=js"
export * from "./Signup.vue?vue&type=script&lang=js"

import "./Signup.vue?vue&type=style&index=0&id=3399c735&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3399c735"

export default script